import { createSelector } from "reselect";
import { get } from "lodash";
import { CourseState } from "store/rootReducer";

const getCourseList = (state: CourseState) => get(state, "course.courseList");

export const getCourseListSelector = createSelector(
  getCourseList,
  (list) => list
);

const getCourseMaterialList = (state: CourseState) =>
  get(state, "course.courseMaterialList");

export const getCourseMaterialListSelector = createSelector(
  getCourseMaterialList,
  (list) => list
);

const getUpdatedSCOList = (state: CourseState) =>
  get(state, "course.isCourseEdited");

export const getUpdatedSCOListSelector = createSelector(
  getUpdatedSCOList,
  (list) => list
);
